import { BusinessLocation } from '@/models/businesses/business-location';
import { axiosService } from '.';
import { GenericResult } from '../models/common/results/generic-result';

export default class BusinessLocationsService {
    public async newBusinessLocation(businessId: number, location: BusinessLocation): Promise<GenericResult> {
        return new GenericResult((await axiosService.instance.post(`businesses/organization/locations/${businessId}/new`, location)).data);
    }

    public async getBusinessLocation(businessId: number): Promise<BusinessLocation> {
        return new BusinessLocation((await axiosService.instance.get(`businesses/organization/locations/${businessId}`)).data);
    }

    public async updateBusinessLocation(businessId: number, location: BusinessLocation): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/locations/${businessId}/update`, location)).data;
    }
}

export const businessLocationsService = new BusinessLocationsService();
